<template>
  <span
    :class="{
      'f-weight-bold': bold,
      'f-size-xx-small': xxsmall,
      'f-size-x-small': xsmall,
      'f-size-small': small,
      'f-size-medium': medium,
      'f-size-large': large,
      'f-family-ja-contract': jaContract,
      'f-family-en-contract': enContract
    }"
    :style="{
      color: color
    }"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'SpanText',
  props: {
    xxsmall: {
      type: Boolean,
      required: false,
      default: false
    },
    xsmall: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    medium: {
      type: Boolean,
      required: false,
      default: false
    },
    large: {
      type: Boolean,
      required: false,
      default: false
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    jaContract: {
      type: Boolean,
      required: false,
      default: false
    },
    enContract: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
